// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2-doC","footer":"ModalFilter_footer__1U1uA"};